/**
 * The give card's own words (GH-878, owner TestFlight feedback on build 36), in one place for the
 * iPhone's give card and the donor web's checkout. The Swift twin is `GiveCardCopy.swift`;
 * `apps/give-card-copy.test.ts` holds the two equal character for character and every label to
 * five words.
 *
 * What is **not** here, on purpose: any sentence that says what processing costs or what declining
 * does. Those are the server's (`costSupportLabel`, `costSupportDeclineNote` on the quote) because
 * how the fee is characterized is DEC-007 / DEC-028's call, not a view's, and they sit behind the
 * ⓘ beside "Cover processing". "Cover processing" itself is the owner's wording (2026-10-04) and
 * matches the itemized name the server already uses everywhere, "Processing fee"
 * (`COVERED_FEE_LABEL`, GH-839).
 */
export const GIVE_CARD_COPY = {
    /* The fee checkbox, right-aligned to the Give button's edge. */
    coverProcessing: "Cover processing",
    /* The ⓘ beside it: its sheet's title. The body is the server's two sentences. */
    coverProcessingExplainTitle: "About covering processing",
    /* The note, behind an icon at the row's leading edge. */
    addNote: "Add a note",
    editNote: "Edit your note",
    noteField: "Note to the organization",
    removeNote: "Remove note",
    /*
     * Under the open note (GH-887): the donor's own, unticked choice to ask for the note on the
     * event's big screen. Five words (the label rule); "my note" is implied by where it sits, and
     * VoiceOver/aria read it with the note field.
     */
    noteOnScreen: "Show on the event screen",
    noteOnScreenExplainTitle: "About the event screen",
    /* The name shown with the gift, behind an icon at the row's trailing edge. */
    addName: "Add your name",
    editName: "Edit your name",
    nameField: "Name to show",
    nameFieldAccessibility: "Name to show publicly",
    removeName: "Remove name",
    /* Under the open name field: the one thing a name changes. */
    nameShownPublicly: "Shown with your gift",
    /*
     * The name control while the gift is anonymous (owner 2026-10-10: a signed-in donor's gift now
     * leads with their name on file; one tap makes it anonymous, another opens the field, a third
     * returns to the name on file).
     */
    anonymous: "Anonymous",
    /* The designation icon on the additions line (owner 2026-10-10: not in the card by default). */
    whatItSupports: "What it supports",
    /* The link at the button's foot, left of "Terms agreed" (owner 2026-10-10). */
    pledgeInstead: "Pledge instead",
};
/**
 * Whether donors are offered "Show on the event screen" at all (GH-887). Held off from 2026-10-05
 * pending counsel; the owner turned it on 2026-10-10 ("troubleshoot why it is not being sent to
 * live control to approve or show" — it was this flag), with counsel's review of the draft
 * Privacy Policy / Terms paragraphs remaining on the open-actions list. On, both give boxes draw
 * the checkbox and a ticked gift reaches the console's approval queue (`screen-notes.ts`). The
 * Swift twin is `GiveCardCopy.noteOnScreenOffered`.
 */
export const NOTE_ON_SCREEN_OFFERED = true;
/**
 * What ticking "Show on the event screen" does (GH-887), behind its ⓘ. Sentences, not labels, so
 * they are outside the five-word rule; the Swift twin is `GiveCardCopy.noteOnScreenExplanation`.
 * A promise the server keeps (`public-feed.ts`, `screen-notes.ts`) — change both together.
 */
export const NOTE_ON_SCREEN_EXPLANATION = [
    "Your note stays private to the organization unless you tick this.",
    "If you do, the organization reviews it first; once approved it can appear with your gift on the event's screen.",
    "Your name appears with it only if you added your name. Anonymous gifts show the note alone.",
];
/**
 * The room's words for the question the speaker is on (GH-878), shared by the console, the big
 * screen, the donor web and the app. Twin: `EngagementCopy.swift`.
 */
export const ENGAGEMENT_COPY = {
    answeringNow: "Answering now",
    /* A prompt the organizer took off the room, on the phone that had it open. */
    offTheRoomTitle: "Not open right now",
};
/** Every label that is drawn on a screen: five words or fewer (DESIGN.md "Five words on screen"). */
export const GIVE_CARD_LABELS = [
    ...Object.values(GIVE_CARD_COPY),
    ...Object.values(ENGAGEMENT_COPY),
];
//# sourceMappingURL=give-card-copy.js.map